const sectionsFaqAdvanced = document.querySelectorAll('.faq-advanced');

if (sectionsFaqAdvanced.length > 0) {

    sectionsFaqAdvanced.forEach(faqAdvanced => {
    
        const faqAdvancedTabs = faqAdvanced.querySelectorAll('.faq-advanced_items .item');
    
        faqAdvancedTabs.forEach(item => {
            item.addEventListener('click', () => {
                faqAdvancedTabs.forEach(otherItem => {
                    if (otherItem !== item && otherItem.getAttribute('open') != null) {
                        otherItem.style.paddingBottom = `0px`;
                        otherItem.removeAttribute('open');
                    }
                });
    
                const itemContent = item.querySelector('.item__content');
                if(item.getAttribute('open') != null){
                    item.style.paddingBottom = `0px`;
                    item.removeAttribute('open');
                }else{
                    item.style.paddingBottom = `${itemContent.offsetHeight+60}px`
                    item.setAttribute('open', '');
                }
            });
        });

    })
}